import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import CityInput from "@/components/CityInput";
import TradeSelect from "@/components/TradeSelect";
import RadarButton from "@/components/RadarButton";

const SearchBar = forwardRef(function SearchBar({ initial, onSubmit }, ref) {
  const [metier, setMetier] = useState(initial?.metier || "architecte");
  const [commune, setCommune] = useState(initial?.commune || null);
  const [cityError, setCityError] = useState("");
  const [loadError, setLoadError] = useState("");
  const cityRef = useRef(null);
  const resolverRef = useRef(null);

  useImperativeHandle(ref, () => ({ focus: () => cityRef.current?.focus() }));

  const submit = async (e) => {
    e.preventDefault();
    let c = commune;
    if (!c) c = await resolverRef.current?.resolve();
    if (!c) {
      setCityError("Choisis ta ville dans la liste.");
      cityRef.current?.focus();
      return;
    }
    setCityError("");
    onSubmit({ metier, commune: c });
  };

  const message = loadError || cityError;

  return (
    <form onSubmit={submit} noValidate data-testid="radar-form" className="relative mx-auto w-full max-w-[680px] text-left">
      <div
        data-testid="search-bar"
        className="flex flex-col gap-2.5 sm:flex-row sm:items-center sm:gap-1 sm:rounded-full sm:border sm:border-line sm:bg-surface sm:p-1 sm:transition-[border-color] sm:duration-150 sm:focus-within:border-[color:var(--accent)]"
      >
        <div className="relative flex h-[52px] min-w-0 items-center rounded-full border border-line bg-surface pl-1 pr-1 transition-[border-color] duration-150 focus-within:border-[color:var(--accent)] sm:static sm:h-[49px] sm:flex-1 sm:border-0 sm:bg-transparent sm:focus-within:border-0">
          <TradeSelect value={metier} onChange={setMetier} />
          <span className="mx-1 h-6 w-px shrink-0 bg-line" aria-hidden="true" />
          <CityInput
            bare
            value={commune}
            inputRef={cityRef}
            resolverRef={resolverRef}
            onLoadError={setLoadError}
            onChange={(c) => {
              setCommune(c);
              if (c) setCityError("");
            }}
          />
        </div>
        <RadarButton type="submit" data-testid="radar-submit" className="shrink-0 sm:w-[220px]">
          Lancer le radar
        </RadarButton>
      </div>
      {message && (
        <p data-testid="city-error" className="mt-2 px-4 text-[13px] err-msg text-ink">
          {message}
        </p>
      )}
    </form>
  );
});

export default SearchBar;
